import { TAsyncThunkAction } from 'shared/types/redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { ITagOption } from '@cian/ui-kit';
import { modifyJsonQueryByRemovingTag, parseTagValue } from '../../../packages/Tags';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { updateSearchMeta } from '../searchMeta';
import { selectTags } from 'shared/selectors/tags';
import { setTags } from 'shared/slices/tags';
import { updateLastAppliedFilter } from 'shared/slices/searchMetaTooltip';

export const removeTag =
  (tag: ITagOption): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();

    const jsonQuery = selectJsonQuery(state);
    const tags = selectTags(state);

    const nextJsonQuery = modifyJsonQueryByRemovingTag({ jsonQuery, removingTagValue: tag.value });
    const nextTags = tags.filter(({ value }) => value !== tag.value);
    const tagFilter = getTagFilter(tag.value);

    dispatch(setJsonQuery(nextJsonQuery));
    dispatch(setTags(nextTags));
    dispatch(updateLastAppliedFilter(tagFilter));
    dispatch(updateSearchMeta());
  };

function getTagFilter(tagValue: string) {
  const [tagId] = parseTagValue(tagValue);

  if (tagId.includes('geo')) {
    return 'geo';
  }

  return 'advancedFilters';
}
